import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import fetchSalon from 'actions/fetchSalon.action';
import { abeSalonCoreUpdate } from 'actions/scheduler/beSalonCore.action';
import TypedOption from 'components/form/TypedOption.component';
import OverlaySpinner from 'components/generic/OverlaySpinner.component';
import useAsyncFnFix from 'hooks/useAsyncFnFix.hook';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import { selectCurrentSalonHideDeletedStylistColumn } from 'selectors/currentSalon.selectors';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import CN from './HideDeletedStaff.module.scss';

const L = logger('HideDeletedStaff');

const HideDeletedStaff = ({ abeSalonCoreUpdate, fetchSalon, isHideDeletedStylistColumn }) => {
  const salonId = useCurrentSalonId();
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const { val: isDeletedStaffRendered, set: setDeletedStaff } = useTip(isHideDeletedStylistColumn);

  const [columnResultVisibility, handleChangeColumnVisibility] = useAsyncFnFix(async () => {
    const result = await abeSalonCoreUpdate({
      data: { hideDeletedStylistColumn: !isDeletedStaffRendered },
    });
    const json = asObject(result.json);

    if (!result.is.ok) {
      L.warn('handleChangeColumnVisibility()', 'result:', result);
      return;
    }

    setDeletedStaff(json.hideDeletedStylistColumn);
    await fetchSalon(salonId);
  }, [isDeletedStaffRendered, abeSalonCoreUpdate, setDeletedStaff, fetchSalon, salonId]);

  const isSpinnerRendered = columnResultVisibility.loading;

  if (columnResultVisibility.error) {
    L.warn('()', { columnResultVisibility });
  }

  return (
    <div
      data-bem="HideDeletedStaff"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      {isSpinnerRendered && <OverlaySpinner />}
      <div data-bem="HideDeletedStaff__checkbox" className={CN.checkboxContainer} role="button" onClick={handleChangeColumnVisibility} tabIndex={0}>
        <TypedOption type="simple-checkbox" name="HideDeletedStaff__TypedOption" checked={isDeletedStaffRendered} onCheck={handleChangeColumnVisibility}>
          <div data-bem="HideDeletedStaff__label--simple-checkbox" className={CN.checkboxLabel}>
            {t('scheduler.staffList.hideDeletedStaff')}
          </div>
        </TypedOption>
      </div>
    </div>
  );
};

const HideDeletedStaffHoc = connect(
  (state) => ({
    isHideDeletedStylistColumn: selectCurrentSalonHideDeletedStylistColumn(state),
  }),
  mapActionsToDispatchToProps({
    abeSalonCoreUpdate,
    fetchSalon,
  }),
)(HideDeletedStaff);

export default HideDeletedStaffHoc;
